import React, { Component } from "react";
import sponsor_letter from "../assets/I20/sponsor_letter.JPG";

export default class I20 extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="container">
          <section>
            <header className="section_head">Prerequisites</header>
            <br />
            To begin the issuance of I20 process, you must have received an email from the department or the immigration department. If you
            didn't recieve any, you can reach out to your department for details.
            <br />
            In the email you will get the limited Access Pin which is required for logging into the portal.
            <br />
            You will also receive the link to the portal in the email.
            <hr />
          </section>
          <section>
            <header className="section_head">Where to find the I20 form?</header>
            <br />
            <ul>
              <li>If you satisfy the prerequisites, then you might have the link to compass portal.</li>
              <li>
                You need:
                <ol>
                  <li>University ID (starts with 81 or TEMP)</li>
                  <li>Date of Birth</li>
                  <li>Limited Access PIN</li>
                </ol>
                (If you have the SSO login enabled then you don't need the above
              </li>
              <li>To login with the PIN click on - Login with PIN (New Student/Scholar Login) option inside the blue box</li>
              <li>Fill in the required details and click on login</li>
              <li>
                Once logged in, from the menu, click on{" "}
                <b>
                  <u>"Student Admission and Orientation"</u>
                </b>
              </li>
              <li>
                Here you can find -{" "}
                <b>
                  <u>"International Student Request for an I-20 form"</u>
                </b>{" "}
                option.
              </li>
              <li>Click on this. It has 2 required and 3 optional forms you need to fill. I will go throught the required forms</li>
            </ul>
            <hr />
          </section>
          <section>
            <header className="section_head">Biographical Information</header>
            <br />
            <ul>
              <li>Fill in your name as per your passport</li>
              <li>If you wish to be addressed by any other name click yes and give your preference, otherwise click no </li>
              <li>Provide all the other basic details</li>
              <li>Make sure to fill all details according to passport and also cross check after entering</li>
              <li>
                Provide your current address in home country address and if this the address where you wish to receive your immigration
                documents then keep the mailing address the same
              </li>
              <li>Upload scanned copy of passport</li>
              <li>Once all fields are filled you can submit or you could save as draft for now and submit later</li>
            </ul>
          </section>
          <section>
            <header className="section_head">Academic Program & Funding Information</header>
            <br />
            This form is where you provide documents for your funding and also the details about the program you are choosing to attend at
            UGA
            <ul>
              <li>In Academic level, if you are doing MS which comes under graduate: Select the option - Graduate, Unspecified</li>
              <li>
                In Expected Major fill in the course you have enrolled for - for example: Computer Science or Food Science whichever course
                you have the offer letter for
              </li>
              <li>Now you need to upload the offer letter</li>
              <li>Choose the degree program</li>
              <li>After selecting this you will be able to see the minimum amount you need to show to receive your I20</li>
              <li>
                For example at the time of writing this (March 22) the amount shown is - $42,287.00 which is equivalent to 32,06,050.22 INR
                at the time. You need documents that shows you have this much amount minimum with you. You can provide multiple documents
                like - your income statement, your parent's income or any other source. All of that together should cover this amount.
              </li>
              <li>The campus you are going to enroll, mostly, would be Athens</li>
              <li>
                If you do not have any personal funding (personal funding doesn't include your parents' funds either) - the put 0 in the
                field
              </li>
              <li>
                Fill in the other fields accordingly. If your parents or reatives are funding your education then it comes under family
                funding.
              </li>
              <li>
                Now if you have added family funding, select "yes" for this question - Is some of your funding coming from a family member
                or other individual?
                <br />- Here you need to upload a consent letter that contains the signature of the person funding your education.
              </li>
              <br />
              <div className="container text-center">
                <u>You can find the sponsor letter in the page if you scroll above to the section mentioned in the image below:</u>
                <br />
                <br />
                <img src={sponsor_letter} className="I20_sponsor_image" alt="consent_letter" />
                <br />
                <br />
                At the end you can find a link in red, which is a word document. This doument has template, the member who is funding your
                education has to fill this and sign the document. You can take print out and sign, then upload the scanned copy in the
                option below where it was asking for this document.
              </div>
              <li>Upload all the other financial documents and then submit or save as draft to submit later</li>
              <li className="text-danger">
                If while submitting, the form says to provide correct values under any of your documents, just re-upload the document again
                as it is and then submit.
              </li>
              <li className="text-danger">
                If you get an Internal Server Error message after clicking submit, it is likely because your file uploads are too large. Try
                reducing the size of your files and re-upload.
              </li>
            </ul>
            <hr />
          </section>
          <section>
            After you submit both the forms, you have to wait for approval from the office - it takes 5-10 days.
            <br />
            Check your UGA email to receive notifications of approval. You can also visit the portal to check the status.
            <br />
            After you recieve I20 you can take print out or even request the I20 to be received via post
          </section>
        </div>
      </React.Fragment>
    );
  }
}
